import type { LangTypeMode } from '@/domains/translation/enums';

export type Side = 'left' | 'right' | 'both';

export type Language = string | 'NON';

export interface LanguageState {
    left: Language;
    right: Language;
}

export interface LangOption {
    left: { lang: Language; langType: LangTypeMode };
    right: { lang: Language; langType: LangTypeMode };
}

export const TranslateService = Symbol('TranslateService');

export interface TranslateOptions {
    patentId: string;
    field: string;
    translatedLanguage: string;
    returnOriginalLanguage?: boolean;
    returnTranslatedText?: boolean;
    returnOriginalText?: boolean;
    returnTranslatedLanguage?: boolean;
}

export interface TranslateResult {
    text?: string;
    translatedText?: string;
    originalLanguage?: string;
    translatedLanguage?: string;
    patentId?: string;
}

export interface TranslateService {
    getSpecificField(options: TranslateOptions): Promise<TranslateResult>
}

export const TranslateConfigService = Symbol('TranslateConfigService');

export interface SelectedLanguageState {
    language: 'NON' | 'JP' | 'EN' | 'CN';
    langType: LangTypeMode;
}

export interface TranslateConfigService {
    /**
     * 获取用户配置的语言选项
     */
    getSelectedLanguage(data: { workspaceId?: string; }): Promise<SelectedLanguageState>;
}
